import React from 'react';
import { useFetchGuides } from './hooks/useFetchGuides';
import Appbar from 'components/appbar/Appbar';
import PageHeaderActions from 'components/page-header/PageHeaderActions';
import NewRecordButton from 'components/page-header/NewRecordButton';
import GuideAction from './GuideAction';
import GuideFilterBox from './GuideFilterBox';
import { GuideProvider } from './hooks/useGuide';
import PaginationProvider from 'hooks/pagination';
import TableLoading from 'components/loading/TableLoading';
import ModuleLoading from 'components/loading/ModuleLoading';
import { useDisplayMode } from 'hooks/useDisplayMode';
import GuideListTable from './list/table/GuideListTable';
import NoData from 'components/no-data/NoData';
import Pagination from 'components/pagination/Pagination';
import GuideListModule from './list/module/GuideListModule';
import ViewGuide from './dialog/ViewGuide';
import ConfirmDialog from 'components/confirm-dialog/ConfirmDialog';

const Guide: React.FC = () => {
  const {
    guides,
    filter,
    total,
    rows,
    handleChange,
    handleSearch,
    loading,
    anchorEl,
    setAnchorEl,
    setSelectedGuide,
    setCancelGuide,
    cancelGuide,
    setViewGuide,
    viewGuide,
    selectedGuide,
    handleSort,
    order,
    page,
    setPage,
    setRows,
    handleCancelGuide,
    canceling,
    onExited,
    finishGuide,
    setFinishGuide,
    handleFinishGuide,
    noShowGuide,
    setNoShowGuide,
    handleNoShowGuide,
  } = useFetchGuides();
  const [displayMode] = useDisplayMode();

  return (
    <GuideProvider
      value={{
        filter,
        handleChange,
        handleSearch,
        loading,
        anchorEl,
        setAnchorEl,
        selectedGuide,
        setSelectedGuide,
        setFinishGuide,
        setNoShowGuide,
        setViewGuide,
        viewGuide,
        setCancelGuide,
      }}
    >
      <Appbar title="Guias" ActionsComponent={<GuideAction />} />
      <PageHeaderActions
        title="Guias"
        description="Gestão de guias"
        ActionComponent={<NewRecordButton label="Nova guia" to="/guides/new" />}
      />
      {selectedGuide && finishGuide && (
        <ConfirmDialog
          confirmLabel="Concluir guia"
          cancelLabel="Voltar"
          title="Deseja marcar a guia como concluída?"
          handleNoClick={onExited}
          handleYesClick={handleFinishGuide}
        />
      )}
      {selectedGuide && noShowGuide && (
        <ConfirmDialog
          confirmLabel="Marcar falta"
          cancelLabel="Voltar"
          title="Deseja marcar que a paciente faltou?"
          handleNoClick={onExited}
          handleYesClick={handleNoShowGuide}
        />
      )}
      {selectedGuide && viewGuide && <ViewGuide guide={selectedGuide} onExited={onExited} />}
      {selectedGuide && cancelGuide && (
        <ConfirmDialog
          confirmLabel="Cancelar guia"
          destructive
          cancelLabel="Voltar"
          title="Deseja realmente cancelar essa guia?"
          handleYesClick={handleCancelGuide}
          handleNoClick={onExited}
        />
      )}
      <GuideFilterBox filter={filter} handleChange={handleChange} handleSearch={handleSearch} loading={loading} />

      {loading ? (
        displayMode === 'list' ? (
          <TableLoading />
        ) : (
          <ModuleLoading />
        )
      ) : guides.length === 0 ? (
        <NoData message="Nenhuma guia encontrada" />
      ) : (
        <PaginationProvider rowsPerPage={rows}>
          {displayMode === 'list' ? (
            <GuideListTable handleSort={handleSort} order={order} guides={guides} />
          ) : (
            <GuideListModule guides={guides} />
          )}

          <Pagination
            count={total}
            currentPage={page}
            currentRowsPerPage={rows}
            onChangePage={page => setPage(page)}
            onChangeRowsPerPage={rows => setRows(rows)}
          />
        </PaginationProvider>
      )}
    </GuideProvider>
  );
};

export default Guide;
